import { useBikesStore } from '@bikes/store/store';
import {
  BikesType,
  BikesTypeLabel,
} from '@bikes/store/storeSlices/bikesDetails';
import { capitalizeWord } from '@utils';

export const SelectedLocationTextContent = () => {
  const { bikesType, serviceLocationDetails } = useBikesStore();
  return (
    serviceLocationDetails.full_address && (
      <div className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]">
        <p className="font-semibold text-black">
          {`${capitalizeWord(BikesTypeLabel[bikesType as BikesType])} location`}
        </p>
        <p className="font-normal text-black">
          {serviceLocationDetails.full_address}
        </p>
      </div>
    )
  );
};
